/**
 * @file fullscreen-toggle.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _buttonJs = require('../button.js');

var _buttonJs2 = _interopRequireDefault(_buttonJs);

var _componentJs = require('../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _utilsFnJs = require('../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

/**
 * Toggle fullscreen video
 *
 * @extends Button
 * @class FullscreenToggle
 */

var FullscreenToggle = (function (_Button) {
  _inherits(FullscreenToggle, _Button);

  function FullscreenToggle(player, options) {
    var _this = this;

    _classCallCheck(this, FullscreenToggle);

    _Button.call(this, player, options);

    player.on('ready', function () {
      _this.player_.on('fullscreenchange', Fn.bind(_this, _this.updateHint));
    });
  }

  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */

  FullscreenToggle.prototype.buildCSSClass = function buildCSSClass() {
    return 'vjs-fullscreen-control ' + _Button.prototype.buildCSSClass.call(this);
  };

  /**
   * Handles click for full screen
   *
   * @method handleClick
   */

  FullscreenToggle.prototype.handleClick = function handleClick() {
    if (!this.player_.isFullscreen()) {
      this.player_.requestFullscreen();
    } else {
      this.player_.exitFullscreen();
    }

    this.updateHint();
  };

  /**
   * Update button controlText
   *
   * @method update
   */

  FullscreenToggle.prototype.updateHint = function updateHint() {
    if (this.player_.isFullscreen()) {
      this.controlText('Exit fullscreen');
    } else {
      this.controlText('Fullscreen');
    }
  };

  return FullscreenToggle;
})(_buttonJs2['default']);

FullscreenToggle.prototype.controlText_ = 'Fullscreen';

_componentJs2['default'].registerComponent('FullscreenToggle', FullscreenToggle);
exports['default'] = FullscreenToggle;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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